var ColumnDataStorage = /** @class */ (function () {
    /**
     * @param {Object} editvalue
     */
    function ColumnDataStorage(editvalue) {
        this.name = editvalue.column_name;
        this.id = editvalue.id;
        this.current_revision = 0;
        this.revisions = [editvalue.value];
        this.formattedValue = editvalue.formatted_value ? editvalue.formatted_value : editvalue.value;
    }
    ColumnDataStorage.prototype.getCell = function () {
        return AdminColumns.Table.Cells.get(this.id, this.name);
    };
    ColumnDataStorage.prototype.setFormattedValue = function (value) {
        this.formattedValue = value;
    };
    ColumnDataStorage.prototype.getFormattedValue = function () {
        return this.formattedValue;
    };
    ColumnDataStorage.prototype.setCurrentRevision = function (index) {
        this.current_revision = index;
        return this;
    };
    ColumnDataStorage.prototype.getCurrentRevision = function () {
        return this.current_revision;
    };
    ColumnDataStorage.prototype.getValue = function () {
        return this.revisions[this.getCurrentRevision()];
    };
    ColumnDataStorage.prototype.updateValue = function (content) {
        return this.getCell().el.target.innerHTML = content ? content : this.getValue();
    };
    ColumnDataStorage.prototype.storeRevision = function (value) {
        var num_deletes = this.revisions.length - this.getCurrentRevision() - 1;
        // Remove any revision that are newer than the current revision
        for (var i = 0; i < num_deletes; i++) {
            this.revisions.pop();
        }
        this.revisions.push(value);
        this.setCurrentRevision(this.getCurrentRevision() + 1);
        return this;
    };
    ColumnDataStorage.prototype.save = function () {
        return jQuery.ajax({
            url: ajaxurl,
            data: {
                action: 'acp_editing_single_request',
                method: 'save',
                list_screen: AC.list_screen,
                layout: AC.layout,
                column: this.name,
                id: this.id,
                screen: AC.screen,
                value: this.getValue(),
                _ajax_nonce: AC.ajax_nonce
            },
            method: 'POST',
            dataType: 'json'
        });
    };
    ColumnDataStorage.prototype.undo = function () {
        if (!this.prev()) {
            return false;
        }
        return true;
    };
    ColumnDataStorage.prototype.redo = function () {
        if (!this.next()) {
            return false;
        }
        return true;
    };
    /**
     * @returns {boolean}
     */
    ColumnDataStorage.prototype.prev = function () {
        var currentRevision = this.getCurrentRevision();
        if (currentRevision === 0) {
            return false;
        }
        this.setCurrentRevision(currentRevision - 1);
        return true;
    };
    /**
     * @returns {boolean}
     */
    ColumnDataStorage.prototype.next = function () {
        var currentRevision = this.getCurrentRevision();
        if (currentRevision === (this.revisions.length - 1)) {
            return false;
        }
        this.setCurrentRevision(currentRevision + 1);
        return true;
    };
    return ColumnDataStorage;
}());
export default ColumnDataStorage;
